import React from 'react';
import { rankingsApi } from '~/routes/api'
import LayoutRanking from './components/Layout'

export default function RankingHolandes() {
  return <LayoutRanking
    title="Ranking do IPG Holandês (Índice do Potencial Genético)"
    url={ rankingsApi.self.build({breed: 'HOLANDÊS'}) }
  />
}